__turbopack_context__.v({
  "calendar": "B2aQ0W_calendar",
});
